<template>
  <tbody>
    <tr>
      <td>
        {{ match.matchTypeFileDate | formatDateMMDDYYYY }}
      </td>
      <td>
        {{ match.matchDate | formatDateMMDDYYYY }}
      </td>
      <td>
        {{ match.schoolYear }}
      </td>
      <td>
        {{ programDescription }}
      </td>
      <td>
        Match
      </td>
      <td>
        {{ match.programUniqueId }}
      </td>
      <td>
        {{ match.matchType.description }}
      </td>
      <td>
        <div>
          <div v-if="match.districtCode">
            <router-link
              :to="{
                name: 'DmDistrictInfoDetails',
                params: { code: match.districtCode }
              }"
              class="has-text-weight-bold has-text-primary"
              style="font-size:14px"
            >
              {{ match.district.location.name }}
            </router-link>
            <span
              class="has-text-grey"
              style="padding-left: 0.25rem"
            >
              ({{ match.districtCode }})
            </span>
          </div>
          <div v-else>
            Multiple Districts
          </div>
          <div>
            <div v-if="match.schoolCode">
              <router-link
                :to="{
                  name: 'DmSchoolInfoDetails',
                  params: {
                    districtCode: match.districtCode,
                    schoolCode: match.schoolCode,
                  },
                }"
                class="is-italic"
              >
                {{ match.school.location.name }}
              </router-link>
              <span
                class="has-text-grey is-italic"
                style="padding-left: 0.25rem"
              >
                ({{ match.schoolCode }})
              </span>
            </div>
            <div
              v-else
              class="has-text-grey is-italic"
            >
              Multiple Schools
            </div>
          </div>
        </div>
      </td>
      <td>
        {{ match.sourceId }}
      </td>
      <td>
        {{ match.sourceCode }}
      </td>
      <td>
        <router-link
          :to="{ path: `/directMatch/transactions/${match.matchTransId}/details` }">
          {{ match.matchTransId }}
        </router-link>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    match: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('lookups', [
      'activePrograms',
    ]),
    programDescription() {
      return this.match.studentProgram
        ? this.activePrograms
          .find(p => p.code === this.match.studentProgram.programCode).description
        : this.activePrograms.find(p => p.code === this.match.programCode).description;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
